module.exports = __webpack_public_path__ + "static/media/information-transparent-icon.d4f51bf4.svg";